import React from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatEuro } from "@/lib/format";

export default function ConflictResolverModal({ open, conflict, preview, saving, onClose, onOverwrite, onCreateNew }) {
  if (!conflict) return null;
  const existing = conflict.existing || {};
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="conflict-modal">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <span className="h-9 w-9 rounded-lg bg-amber-100 dark:bg-amber-950/60 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
            </span>
            <DialogTitle className="font-display">Processo já existente</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            Já existe um registo com o Nº Processo <strong>{preview?.numero_processo}</strong>. O que pretende fazer?
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-3 text-sm py-2">
          <div className="rounded-lg border border-border p-3">
            <div className="text-xs font-semibold uppercase text-muted-foreground mb-2">Registo atual</div>
            <div className="space-y-1">
              <div className="truncate">{existing.cliente}</div>
              <div className="truncate text-muted-foreground">{existing.nome_projeto}</div>
              <div className="font-mono-num font-semibold">{formatEuro(existing.valor_total)}</div>
            </div>
          </div>
          <div className="rounded-lg border border-primary/40 bg-primary/5 p-3">
            <div className="text-xs font-semibold uppercase text-primary mb-2">Novo ficheiro</div>
            <div className="space-y-1">
              <div className="truncate">{preview?.cliente}</div>
              <div className="truncate text-muted-foreground">{preview?.nome_projeto}</div>
              <div className="font-mono-num font-semibold">{formatEuro(preview?.valor_total)}</div>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose} disabled={saving} data-testid="conflict-modal-cancel-button">
            Cancelar
          </Button>
          <Button variant="secondary" onClick={onCreateNew} disabled={saving} data-testid="conflict-modal-createnew-button">
            Criar registo novo
          </Button>
          <Button onClick={onOverwrite} disabled={saving} data-testid="conflict-modal-overwrite-button">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Atualizar existente"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
